// Libraries
import { Table, BinSearch } from '../../components';
import BinHeader from './BinHeader';
import {
    fetchBinDataRequest,
    uploadBinFileRequest,
    uploadBinFileError,
    downloadByIdRequest,
} from './redux/manageBin.actions';
import React, { useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

// Layouts

// Components

// Actions

// Styles
import './manageBin.scss';
import BinFormatting from 'components/BinFormatting';

const ManageBinActions = ({ data, downloadRequest }) => {
    const handleDownload = () => {
        if (data.original) {
            const { requestId } = data.original;
            const request = {
                fileTypeEnum: 'PROCESSED',
                requestId,
            };
            downloadRequest(request);
        }
    };

    const getDisableClass = data => {
        if (data) {
            const { requestStaus } = data;
            if (requestStaus !== 'Completed') {
                return 'disabled';
            }
        }
        return '';
    };

    return (
        <div className="userAction  multiItem">
            <button
                className={`download ${getDisableClass(data.original)}`}
                onClick={handleDownload}
            />
        </div>
    );
};

const TableHead = props => {
    return (
        <div className="mail-head clearfix">
            <div className="headTitle">
                <p>Recent Uploaded</p>
            </div>
        </div>
    );
};

const ManageBin = props => {
    const {
        manageBin,
        actions,
        loader: { showLoader },
    } = props;

    const { error, tableData, isLoading, uploadFile } = manageBin;

    const columnsRecent = useMemo(
        () => [
            { header: 'File Name', accessor: 'fileName' },
            { header: 'Uploaded Date', accessor: 'uplodedDate' },
            { header: 'Upload status', accessor: 'requestStaus' },
            { header: 'Record Count', accessor: 'totalRecordCount' },
            { header: 'Updated Count', accessor: 'successRecordCount' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    // We'll start our table without any data

    const fetchData = useCallback(() => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,

        actions.fetchBinDataRequest();
    }, [actions]);

    useEffect(() => {
        if (uploadFile.isSuccess) {
            fetchData();
            actions.uploadBinFileError({ error: {} });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadFile.isSuccess]);

    return (
        <Switch>
            <Route exact path="/manage-bin">
                <div className="manage-bin-wrapper">
                    <BinHeader uploadFile={actions.uploadBinFileRequest} />
                    <Table
                        columns={columnsRecent}
                        data={tableData}
                        tableHead={<TableHead />}
                        error={error && error.errorMessage}
                        loading={showLoader || isLoading}
                        fetchData={fetchData}
                        userActions={data => (
                            <ManageBinActions
                                data={data}
                                downloadRequest={value =>
                                    actions.downloadByIdRequest(value)
                                }
                            />
                        )}
                        tableFilters={null}
                    />
                </div>
            </Route>
            <Route exact path="/manage-bin/formatting">
                <BinFormatting />
            </Route>
            <Route exact path="/manage-bin/search/:searchValue">
                <BinSearch />
            </Route>
        </Switch>
    );
};

const mapStateToProps = ({ auth, manageBin, loader }) => ({
    auth,
    manageBin,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchBinDataRequest,
            uploadBinFileRequest,
            uploadBinFileError,
            downloadByIdRequest,
        },
        dispatch
    ),
});

ManageBin.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    manageBin: PropTypes.object,
    loader: PropTypes.object,
};

ManageBinActions.propTypes = {
    data: PropTypes.object,
    downloadRequest: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageBin);
